import { render, staticRenderFns } from "./SiteProvidersTable.vue?vue&type=template&id=4a6d5672"
import script from "./SiteProvidersTable.vue?vue&type=script&lang=js"
export * from "./SiteProvidersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports